export default {
  metrics: {
    pickup: 'Abholung',
    internal_delivery: 'Interne Lieferung',
    external_delivery: 'Externe Lieferung',
  },
  events: {
    add_to_basket: 'Artikel hinzufügen',
    begin_checkout: 'Zur Kasse gehen',
    begin_purchase: 'Zahlung einleiten',
    complete_purchase: 'Vollständige Bezahlung',
    order_placed: 'Vollständige Bezahlung',
    view_item: 'Produkt ansehen',
  },
};
